module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/show-b8af385e0228710aa95d40728e2a3b91.png";